import { Header as AzoyaHeader, Logo, Button } from '@azoya-spa/ui'
import '@azoya-spa/ui/styles.css'
import { Link, NavLink } from 'react-router-dom';
import { bookingCtaClicked } from '../../analytics/events'

const NAV_LINKS = [
  {to: '/accueil', label: 'Accueil'},
  {to: '/services', label: 'Services'},
  {to: '/offres-abonnement', label: 'Offres/Abonnement'},
]

function Header() {
  return (
    <AzoyaHeader
      logo={<Link to="/accueil" aria-label="Accueil - Azoya Spa Vaux"><Logo size={64} /></Link>}
      nav={(close) => NAV_LINKS.map(({to, label}) => (
        <NavLink key={to} to={to} onClick={close} className={({isActive}) => isActive ? 'is-active' : undefined}>
          {label}
        </NavLink>
      ))}
      cta={
        <Button as={Link} to="/reserver-en-ligne" onClick={() => bookingCtaClicked('header')}>
          Réserver en ligne
        </Button>
      }
    />
  );
}

export default Header;
